import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import type { SharedModalState } from './sharedModal.types';

const getSharedModalState = (state: RootState): SharedModalState => state.sharedModal;

const isWeblinkOpened = createSelector(getSharedModalState, (state) => state.weblinkOpened);

export const SharedModalSelectors = {
    isWeblinkOpened,
} as const;
